
<div class="language-suggest">
  <div class="container">
    <div class="language-suggest--inner">
      <div class="language-suggest--label">
        <img [ngSrc]="'/assets/i18n/flags/' + localeId + '.svg'" height="20" width="10" [alt]="'Flag' + localeId">
        <span>{{ content.label }}</span>
      </div>
      <div class="language-suggest--actions">
        <a [href]="'/' + localeId + '/' + path" class="language-suggest--button" (click)="select()">
          {{ content.action }}
        </a>
        <app-icon class="language-suggest--hide" (click)="hide()">
          clear
        </app-icon>
      </div>
    </div>
  </div>
</div>
